export default {"src":"/_next/static/media/search.3a2dc72f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};